module.exports = __webpack_public_path__ + "img/2.678691c3.jpg";